<template>
    <v-alert color="primary" dark border="left" prominent>
        <template v-slot:prepend>
            <v-icon>mdi-check-circle</v-icon>
        </template>
        {{ $t('partner.job.is_completed') }}
    </v-alert>
</template>


<script>
export default {
    name: 'FinalizedJobBanner',
    props: {},
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {},

    watch: {},
};
</script>


<style lang='scss' scoped></style>